module.exports = __webpack_public_path__ + "media/images/ages-6c25886918d6fdc28ee22f8e8b7759f6.png";